
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --body-color:var(--brand-white);
  --hero-fixed-height:240px;
  --aspect-ratio-large:16 / 9;
  --aspect-ratio-medium:16 / 5;
  --aspect-ratio-small:16 / 3;
}

  :host .outline-hero{
    position:relative;
    background-color:var(--brand-blue-300);
  }

  :host .outline-hero.has-no-background{
    background-color:var(--brand-white);
  }

  :host .outline-hero.has-fixed-height .outline-hero--background,
  :host .outline-hero.has-fixed-height .background{
    height:var(--hero-fixed-height);
  }

  :host .outline-hero--background{
    display:none;
  }

  :host .outline-hero.aspect-ratio-small .outline-hero--background{
      aspect-ratio:var(--aspect-ratio-small);
    }

  :host .outline-hero.aspect-ratio-medium .outline-hero--background{
      aspect-ratio:var(--aspect-ratio-medium);
    }

  :host .outline-hero.aspect-ratio-large .outline-hero--background{
      aspect-ratio:var(--aspect-ratio-large);
    }

:host([has-background]) .outline-hero--content{
    position:absolute;
  }

:host([has-background]) .outline-hero--background{
    display:flex;

    min-height:var(--hero-background--min-height);
  }

:host([has-background]) .background{
    display:flex;
    flex-grow:1;
  }

:host([has-background]) .outline-hero{
    background:none;
  }

.overlay{
  position:absolute;
  inset:0;
  z-index:1;
  background:var(--brand-primary-dark-blue);
  opacity:0.6;
  pointer-events:none;
}

.overlay--no-overlay{
    display:none;
  }

.overlay--30{
    opacity:0.3;
  }

.overlay--80{
    opacity:0.8;
  }

.overlay--100{
    opacity:1;
  }

.outline-hero--content{
  display:flex;
  flex-direction:column;
  justify-content:center;
  top:0;
  bottom:0;
  z-index:1;
  padding:5%;
}

@media (min-width: 1024px){

.outline-hero--content{
    max-width:45%;
    padding-right:0
}
  }

.outline-hero--heading{
  --heading-color:var(--brand-white);

  line-height:var(--lh-headline-4xl);
}

.outline-hero--heading.has-no-background{
  --heading-color:var(--brand-primary-dark-blue);
}

.heading{
  word-break:break-word;
}

@media (min-width: 768px){

.heading{
    word-break:unset
}
  }

.outline-hero--description{
  color:var(--brand-white);
  max-width:85%;
}

.outline-hero--description.has-no-background{
  color:var(--brand-primary-dark-blue);
}

.outline-hero--background{
  display:flex;
  width:100%;
  flex-direction:column;
  overflow:hidden;
}
`;